import { OrganizationStats } from '@/models/OrganizationStats';
import { OrganizationStatsRequest } from '@/models/OrganizationStatsRequests';
import { PasswordRules } from '@/models/PasswordRules';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { AppOrganization, AppOrganizationTypes, SetConfigRequestData } from './types';

export const getAppOrgRequest = (data: string) => action(AppOrganizationTypes.GET_APP_ORGANIZATION_REQUEST, data);
export const getAppOrgSuccess = (data: AppOrganization) => action(AppOrganizationTypes.GET_APP_ORGANIZATION_SUCCESS, { data });
export const getAppOrgFailure = () => action(AppOrganizationTypes.GET_APP_ORGANIZATION_FAILURE);

export const setConfigRequest = (data: SetConfigRequestData) => action(AppOrganizationTypes.SET_CONFIG_REQUEST, data);
export const setConfigSuccess = () => action(AppOrganizationTypes.SET_CONFIG_SUCCESS);
export const setConfigFailure = (error: AxiosError) => action(AppOrganizationTypes.SET_CONFIG_FAILURE, error);

export const getPasswordRulesRequest = (orgId: number) => action(AppOrganizationTypes.GET_PASSWORD_RULES_REQUEST, orgId);
export const getPasswordRulesSuccess = (data: PasswordRules) => action(AppOrganizationTypes.GET_PASSWORD_RULES_SUCCESS, data);
export const getPasswordRulesFailure = () => action(AppOrganizationTypes.GET_PASSWORD_RULES_FAILURE);

export const getOrganizationStatsRequest = (data: OrganizationStatsRequest) => action(AppOrganizationTypes.GET_ORGANIZATION_STATS_REQUEST, data);
export const getOrganizationStatsSuccess = (data: OrganizationStats) => action(AppOrganizationTypes.GET_ORGANIZATION_STATS_SUCCESS, data);
export const getOrganizationStatsFailure = (error: AxiosError) => action(AppOrganizationTypes.GET_ORGANIZATION_STATS_FAILURE, error);
